import { render, staticRenderFns } from "./ContentEmergencyButtonBlock.vue?vue&type=template&id=23582a72&scoped=true"
import script from "./ContentEmergencyButtonBlock.vue?vue&type=script&lang=js"
export * from "./ContentEmergencyButtonBlock.vue?vue&type=script&lang=js"
import style0 from "./ContentEmergencyButtonBlock.vue?vue&type=style&index=0&id=23582a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23582a72",
  null
  
)

export default component.exports